import React from 'react';

import clsx from 'clsx';

import { OperatorHitProps } from 'lib/search';

export default function OperatorHit(props: OperatorHitProps) {
  const {
    hit: { operator, company, truck },
  } = props;
  return (
    <div
      className={clsx(
        'operator-hit clickable my-1 border-2 border-solid',
        props.isHighlighted ? 'border-red-500' : 'border-sky-500'
      )}
      onClick={() => props.onClick(props.hit)}
    >
      <p>
        <i>email: </i>
        {operator.email}
      </p>
      <p>
        <i>nickname: </i>
        {operator.nickname}
      </p>
      <p>
        <i>name: </i>
        {operator.firstName} {operator.lastName}
      </p>
      <p>
        <i>role: </i>
        {operator.role}
      </p>
      <p>
        <i>company: </i>
        {company.name} ({company.companyId})
      </p>
      <p>
        <i>truck: </i>
        {truck.truckType} {truck.bodyType} [{truck.materials?.join(', ')}] (
        {truck.truckId})
      </p>
    </div>
  );
}
